import IconInfo from '../../icons/info';

import cn from './styles.module.css';

export default function CreationDisabledInfo() {
  return (
    <div className={cn.creationDisabledInfo}>
      <IconInfo width={24} height={24} />
      <div className={cn.creationDisabledInfoRight}>
        <div className={cn.creationDisabledInfoTitle}>
          Not sent to Partner Bank via API
        </div>
        <div className={cn.creationDisabledInfoDescription}>
          The transaction was created as already executed on the Partner Bank
          side.
        </div>
      </div>
    </div>
  );
}
